export const MenuList = [
  {
    menu: 'India',
    drop: true
  },
  {
    menu: 'Must-See'
  },
  {
    menu: 'Explore Map'
  },
  {
    menu: 'Why India'
  },
  {
    menu: 'Seasonal Trips'
  }
  // {
  //   menu: 'Reviews'
  // },
  // {
  //   menu: 'FAQ'
  // }
];

export const IndianData = {
  North: {
    Punjab: ['Amritsar'],
    Uttarakhand: [],
    'Himachal Pradesh': [],
    'Jammu and Kashmir': ['Jammu'],
    'Leh and Ladakh': [],
    Delhi: [],
    'Uttar Pradesh': ['Lukhknow', 'Noida']
  },
  West: {
    Gujarat: ['Ahmedabad', 'Surat'],
    'Madhya Pradesh': ['Indore', 'Bhopal'],
    Maharashtra: ['Mumbai', 'Pune'],
    Rajasthan: ['Jaipur', 'Jaiselmer']
  },
  South: {
    'Andaman and Nicobar Islands': [],
    'Andhra Pradesh': ['Tirumala', 'Hydrabad'],
    Karnataka: ['Bangalore', 'Manglore'],
    Kerala: ['Tirchy'],
    Lakshadweep: [],
    Puducherry: [],
    'Tamil Nadu': ['Chennai', 'Rameshwarem']
  },
  East: {
    Chhattisgarh: ['Raipur'],
    Meghalaya: [],
    Assam: [],
    'Arunachal Pradesh': [],
    Sikkim: [],
    'West Bengal': ['Kolkata']
  }
};

export const MostRecentlyVisitedIndianPlace = [
  {
    title: 'Jammu & Kashmir',
    url: '/explore/india/north-india/jammu-and-kashmir/jammu'
  },
  {
    title: 'Rajasthan',
    url: '/explore/india/west-india/rajasthan'
  },
  {
    title: 'Leh Ladakh',
    url: '/explore/india/north-india/leh-and-ladakh'
  },
  {
    title: 'Himachal Pradesh',
    url: '/explore/india/north-india/himachal-pradesh/manali'
  },
  {
    title: 'Kerala',
    url: '/explore/india/south-india/kerala'
  },
  {
    title: 'Andaman & Nicobar',
    url: '/explore/india/south-india/andaman-and-nicobar-islands'
  }
];
